import {InputSProps} from "@FRAMEWORK/ui/types/d";
import styled from "styled-components";

interface InputProps extends InputSProps {
	width?: string;
}

const Number = styled.input<{$isMinValue?: boolean}>`
	width: 40px;
	height: 32px;
	padding: 10px 5px;
	font-size: 15px;
	border-color: var(--border-color);
	border-left: 0;
	border-right: 0;
	text-align: center;
	color: ${({$isMinValue}) => ($isMinValue ? "var(--placeholder-color)" : "var(--sub-title-color)")};
	font-family: "PT-semibold";
`;

const NumberInput = ({width, ...props}: InputProps) => <Number type="text" width={width} {...props} />;

export default NumberInput;
